import Year from './year.vue'
import Photo from './photo.vue'

export default { Year, Photo }
